import { render, staticRenderFns } from "./foldersType.vue?vue&type=template&id=93309b52&scoped=true"
import script from "./foldersType.vue?vue&type=script&lang=js"
export * from "./foldersType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93309b52",
  null
  
)

export default component.exports